import { Typography } from 'antd';
import { TitleProps } from 'antd/lib/typography/Title';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React from 'react';

const styles: InlineStylesModel = {
  formLabel: {
    marginBottom: 0,
    color: 'rgba(0,0,0,0.85)'
  }
};

interface Props extends TitleProps {
  label: string;
  required?: boolean;
}

export const FormLabel: React.FC<Props> = ({ label, required, ...rest }) => {
  return (
    <Typography.Text {...rest} style={styles.formLabel}>
      {label}
      {required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
    </Typography.Text>
  );
};
